import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './CodeVerificationSuccessModal.css';
import cs from '../../components/commonStyle.css';
import { Modal, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import messages from '../../locale/messages';
import success_check from '../../../public/siteImages/successCheck.png';

class CodeVerificationSuccessModal extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
    };

    render() {
        const { onClose, show } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Modal show={show} animation={false} onHide={onClose} className="verificationModal">
                <div className={cx(s.sectionBlock)}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <div className={cx(s.verificationContent, cs.textAlignCenter)}>
                            <img src={success_check} alt="Verification Success" className={s.verificationImage} />
                            <h2 className={cx(s.titleText)}>Your identity has been verified successfully.</h2>
                            <Button className={cx(cs.btnPrimary, cs.fullWidth, cs.commonMediumText)} onClick={onClose}>
                                Great!
                            </Button>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        );
    }
}

const mapState = state => ({});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(CodeVerificationSuccessModal))); 